import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ReferralRedirect = () => {
    const { slug } = useParams(); // 👈 hr5 from /r/:slug
    const decodedSlug = decodeURIComponent(slug);

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const xKey=process.env.REACT_APP_REF_API_KEY
  useEffect(() => {
    const trackReferral = async () => {
      try {
        // fire-and-forget API call (don't block redirect)
        fetch(`${apiUrl}/ref/track/${decodedSlug}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY":xKey
          },
        }).catch(() => {
          // fail silently, user shouldn't feel it
        });
        //   setTimeout(() => {
            navigate("/", { replace: true });
        //   }, 5000);
        // ✅ instantly redirect to homepage
      } catch (error) {
        // even on error, redirect to home
        navigate("/", { replace: true });
      }
    };

    trackReferral();
  }, [slug, navigate,apiUrl,decodedSlug,xKey]);
  
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-center">
      <div className="p-4 rounded shadow-sm bg-white">
        <div className="spinner-border text-primary mb-3" role="status"></div>
        <h5 className="mb-0">Taking you to our website...</h5>
      </div>
    </div>
  );
};

export default ReferralRedirect;
